import { useMutation, useQuery } from '@tanstack/react-query';
import customFieldsService from '../services/customFieldsService';

export const useUpdateCustomField = () => {
	return useMutation({
		mutationKey: ['customField'],
		mutationFn: (data: Partial<UpdateCustomFieldRequest>) =>
			customFieldsService.update<UpdateCustomFieldRequest, CustomField>(
				data,
			),
	});
};

export const useAddCustomField = () => {
	return useMutation({
		mutationKey: ['customField'],
		mutationFn: (data: CreateCustomFieldRequest) =>
			customFieldsService.create<CreateCustomFieldRequest, CustomField>(
				data,
			),
	});
};

export const useGetAllCustomFields = (options?: { isEnabled: boolean }) => {
	return useQuery<TavoittajaApiResponse<{ customFields: CustomField[] }>>({
		queryKey: ['customFields'],
		queryFn: () => customFieldsService.getAllResources(),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetSingleCustomField = (
	id: number,
	options?: {
		isEnabled: boolean;
	},
) => {
	return useQuery({
		queryKey: ['customField', id],
		queryFn: () => customFieldsService.getSingleResource(id),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteMultipleCustomFields = () => {
	return useMutation({
		mutationKey: ['customFields'],
		mutationFn: (data: DeleteMultipleCustomFieldsRequest) =>
			customFieldsService.deleteMultipleResources(data),
	});
};

export const useDeleteCustomField = () => {
	return useMutation({
		mutationKey: ['customField'],
		mutationFn: (id: number) =>
			customFieldsService.deleteSingleResource(id),
	});
};
